import { useCallback } from "react"

import { useGetStartedStore } from "../components/getStarted/useGetStartedStore"
import { QUERY_KEYS } from "../constants"
import { useMissionsQuery } from "../networking/missions/queries"
import { MissionScene, MissionStatus } from "../types"
import { queryClient } from "../util/queryClient"

// This is a function to call after each quest action, to mark the mission as complete,
// and then when it is the last mission, we want to show the animation

const useMarkMissionComplete = (sceneName: MissionScene) => {
  const { data: missions } = useMissionsQuery()
  const { setShowCompleteAnimation } = useGetStartedStore()
  const isMissionIncomplete = !!missions?.find(
    (mission) =>
      mission.scene_name === sceneName &&
      mission.status.status === MissionStatus.INCOMPLETE
  )

  const markMissionComplete = useCallback(() => {
    const isLastMission =
      missions?.filter(
        (mission) => mission.status.status === MissionStatus.INCOMPLETE
      ).length === 1

    if (isMissionIncomplete) {
      queryClient.invalidateQueries([QUERY_KEYS.MISSIONS])
      if (isLastMission) {
        setShowCompleteAnimation(true)
      }
    }
  }, [missions, isMissionIncomplete, setShowCompleteAnimation])

  return markMissionComplete
}

export default useMarkMissionComplete
